export default __webpack_public_path__ + "static/media/unstaking-step-three-skyrim.12c139ae.png";